import {Collapse, List} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import SceneListItem from './scene-list-item.jsx';
import SceneListSubheader from './scene-list-subheader.jsx';
import {trackEvent} from '@explorer/analytics';
import {getSortedGroupItems} from '@explorer/selectors/results';

const ScenesList = ({resultId, canDownload}) => {
  const groups = useSelector(getSortedGroupItems);

  const [expandedGroups, setExpandedGroups] = useState({});

  useEffect(() => {
    if (resultId) {
      trackEvent('Scene List: Shown', {
        itemGroupsCount: groups.length,
      });
    }
  }, [resultId, groups]);

  const toggleGroupExpansion = groupId => {
    setExpandedGroups({...expandedGroups, [groupId]: !expandedGroups[groupId]});
  };
  return (
    <React.Fragment>
      {groups.map((group, groupIndex) => (
        <React.Fragment key={group.id}>
          <SceneListSubheader
            group={group}
            onExpand={() => toggleGroupExpansion(group.id)}
            resultId={resultId}
            groupIndex={groupIndex}
            canUserDownload={canDownload}
          />
          <Collapse in={!!expandedGroups[group.id]} mountOnEnter>
            <List disablePadding>
              {group.features.map((item, itemIndex) => (
                <SceneListItem
                  resultId={resultId}
                  sceneItem={item}
                  key={item.id}
                  groupIndex={groupIndex}
                  itemIndex={itemIndex}
                  canUserDownload={canDownload}
                />
              ))}
            </List>
          </Collapse>
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

ScenesList.propTypes = {
  resultId: PropTypes.string,
  canDownload: PropTypes.bool,
};

export default ScenesList;
